import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api`;

export const financeDataService = {
  async getUserFinancialContext() {
    try {
      const token = localStorage.getItem('firebaseToken');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      const config = {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };

      // Fetch user profile and transactions in parallel
      const [profileResponse, transactionsResponse] = await Promise.all([
        axios.get(`${API_URL}/user/profile`, config),
        axios.get(`${API_URL}/transactions`, config)
      ]);

      return {
        profile: profileResponse.data,
        transactions: transactionsResponse.data
      };
    } catch (error) {
      console.error('Error fetching financial context:', error);
      if (error.response?.status === 401) {
        // Handle unauthorized error (e.g., redirect to login)
        localStorage.removeItem('firebaseToken');
      }
      throw error;
    }
  }
};